import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { MachineRequestType } from "@enums/machineRequestType.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { Machine } from "@interfaces/models/machine.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { ExportLogService } from "@services/exportLog.service";
import { MachineService } from "@services/machine.service";
import { MachineRequestService } from "@services/machineRequest.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { SupervisorRequestReasonService } from "@services/supervisorRequestReason.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "machineRequests",
	styleUrls: ["machineRequests.css"],
	templateUrl: "machineRequests.html"
})
export class MachineRequestsAdminComponent {
	canExportGrid = false;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	itemType = "Machine Request"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any[] = [];
	machineRequestTypes: any = [];
	machines: Machine[] = [];
	people: UserProfile[] = [];
	statuses: any;
	title: string;
	
	constructor(private router: Router, private toastService: ToastService, private exportLogService: ExportLogService, private itemService: MachineRequestService, private machineService: MachineService, private protectedGridService: ProtectedGridService, private supervisorRequestReasonService: SupervisorRequestReasonService, private userProfileService: UserProfileService) {
		this.title = `${this.itemType}s`;
		this.machineRequestTypes = GetPropertiesFromEnum(MachineRequestType);
		this.getItems();
		this.getMachines();
		this.getPeople();
		this.checkGridExportPermissions();
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Machine Requests")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	displayMachineInDropdown(e: any) { 
		return e === null || e === undefined ? "" : (e.cellNumber === null || e.cellNumber === undefined ? "???" : e.cellNumber) + " - " + e.name;
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getAll()
			.subscribe(
				(res: any) => {
					this.items = res.response.items;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getMachines() {
		this.machineService.getAll()
			.subscribe(
				(res: any) => this.machines = res.response.items,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}
	
	getPeople() {
		this.userProfileService.getAllWithUsers()
			.subscribe(
				(res: any) =>  {
					this.people = res.response;
					this.people.sort((a,b) => a.fullName.localeCompare(b.fullName));
				},
				(err) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Machine Requests";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}
}